@if (details$ | async; as details) {
  <div>
    <div class="status-bar {{ details?.statusClass }}">
      <span class="material-icons">{{ status?.icon }}</span>
      {{ status?.message }}
    </div>
  </div>
}
